import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  SET_DATES,
  SET_LOADING,
  SET_UPDATES_LOADING,
  FETCH_CHART_SUCCESS,
  UPDATE_DATES,
  UPDATE_CUSTOM_RANGE,
  SET_FILTERS_DIRTY,
  UPDATE_PDC_TYPE,
  UPDATE_PAYMENT_STATUS,
  RESET_FILTER
} from "./pastDuePerformanceSagas";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOption,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";
import { pdcTypeOptions, paymentStatusOptions } from "../constants";

export const initialState = {
  isLoading: true,
  initialRequest: false,
  updatesLoading: false,
  currentUser: {},
  chartsData: { table: {} },
  filtersDirty: false,
  selectedFilters: {
    pdcType: pdcTypeOptions[1],
    paymentStatus: paymentStatusOptions[1]
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      rangeOptions: getRangeOptions(
        state.currentUser.calendarEndDate,
        state.currentUser.calendarStartDate
      ),
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        rangeOption: getSelectedRangeOption(action.payload.endDate)
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartsData: action.payload
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      filtersDirty: true,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        rangeOption: getSelectedRangeOptionWithCustom(action)
      }
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        ...getDateRanges(
          state.currentUser.calendarEndDate,
          action.payload,
          state.currentUser.calendarStartDate
        ),
        rangeOption: action.payload
      }
    }),
    [UPDATE_PDC_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        pdcType: action.payload
      }
    }),
    [UPDATE_PAYMENT_STATUS]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        paymentStatus: action.payload
      }
    }),
    [RESET_FILTER]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: {
        ...initialState.selectedFilters
      }
    })
  },
  initialState
);
